import { Link as InertiaLink, InertiaLinkProps } from '@inertiajs/react';
import { AnchorHTMLAttributes, PropsWithChildren } from 'react';

const cookieValue =
    typeof document !== 'undefined'
        ? document.cookie
              .split('; ')
              .find((row) => row.startsWith('openLinksInNewTabs='))
              ?.split('=')[1]
        : undefined;

export default function Link({
    inertia = false,
    mayOpenInNewTab = false,
    children,
    ...props
}: PropsWithChildren<{ inertia?: boolean; mayOpenInNewTab?: boolean } & InertiaLinkProps & AnchorHTMLAttributes<HTMLAnchorElement>>) {
    const Tag = inertia ? InertiaLink : 'a';

    if (mayOpenInNewTab) {
        if (cookieValue === undefined || cookieValue === 'true') {
            props.target = '_blank';
        }
    }

    return <Tag {...props}>{children}</Tag>;
}
